import { Component, Host, h, JSX, Prop } from '@stencil/core'

@Component({
    tag: 'zr-tooltip',
    styleUrl: 'zr-tooltip.scss',
    shadow: true,
})

/**
 * ZooRoyal price component.
 */
export class ZrTooltip {
    /**
     * Text of the tooltip.
     */
    @Prop() text: string

    /**
     * Show icon in the tooltip.
     */
    @Prop() showIcon = true

    /**
     * Is the tooltip animated.
     */
    @Prop() isAnimated = true

    /**
     * Api response failed.
     */
    @Prop() apiResponse= true

    /**
     * Disabled the Button.
     */
    @Prop() disabledButton = false

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div part="wrapper" class={{
                    'zr-tooltip__wrapper': true,
                    'is-failed': !this.apiResponse,
                }}>
                    <p part="content" class={{
                        'zr-tooltip__content--disabled': this.disabledButton,
                        'zr-tooltip__content': true,
                        'show-icon': this.showIcon,
                        'is-animated': this.isAnimated,
                    }}>{this.text}</p>
                </div>
            </Host>
        )
    }
}
